import React from 'react';
import { FormError } from '@tanium/react-form-context';
import { Stack } from '@tanium/react-stack';
import { FormInlineError } from './FormInlineError';

export interface Props {
  errors: FormError[];
}

const getErrorMessage = (error: FormError) => {
  if (typeof error === 'object' && 'message' in error) {
    return error.message;
  }
  return error;
};

export const FormInlineErrors = ({ errors }: Props) => (
  <Stack itemSpacing={1} direction="column">
    {errors.map((error, i) => (
      // eslint-disable-next-line react/no-array-index-key -- index is best key available
      <FormInlineError key={i}>{getErrorMessage(error)}</FormInlineError>
    ))}
  </Stack>
);
